import { __ } from '@wordpress/i18n';
import { useState, useEffect } from '@wordpress/element';
import { Icon } from '@wordpress/components';
import { search } from '@wordpress/icons';
import PropTypes from 'prop-types';

const SearchBar = ({ onSearch, activeTab }) => {
	const [query, setQuery] = useState('');
	const [debouncedQuery, setDebouncedQuery] = useState('');

	// Debounce input by 300ms
	useEffect(() => {
		const timer = setTimeout(() => {
			setDebouncedQuery(query);
		}, 300);
		return () => clearTimeout(timer);
	}, [query]);

	// Emit debounced search to parent
	useEffect(() => {
		if (typeof onSearch === 'function') {
			onSearch(debouncedQuery);
		}
	}, [debouncedQuery]);

	const placeholderMap = {
		patterns: __('Search templates...', 'vayu-blocks'),
		pages: __('Search pages...', 'vayu-blocks'),
		kits: __('Search templates...', 'vayu-blocks'),
		favorites: __('Search favorites...', 'vayu-blocks'),
	};

	return (
		<div className="vayu-dl-search-bar-wrapper">
			<label className="screen-reader-text" htmlFor="vayu-dl-search-input">
				{__('Search', 'vayu-blocks')}
			</label>
			<Icon icon={search} className="vayu-dl-search-icon" />
			<input
				id="vayu-dl-search-input"
				type="text"
				className="vayu-dl-search-input"
				placeholder={placeholderMap[activeTab] || __('Search...', 'vayu-blocks')}
				value={query}
				onChange={(e) => setQuery(e.target.value)}
				aria-label={__('Search input', 'vayu-blocks')}
			/>
		</div>
	);
};

SearchBar.propTypes = {
	onSearch: PropTypes.func.isRequired,
	activeTab: PropTypes.string.isRequired,
};

export default SearchBar;
